import React, { FC, useEffect } from 'react';

import { Categories } from '@ariksa/inventory-core/api';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Card } from 'components/DataDisplay';
import { actions } from 'containers/Setup/DataConfiguration/slice';
import { actions as sharedStateActions } from 'containers/SharedState/slice';

import { DataClassifierForm } from './DataClassifierForm';

export const AddDataClassifier: FC = () => {
  const dispatch = useDispatch();
  const { type: selectedTab } = useParams<{ type: string }>();

  useEffect(() => {
    selectedTab === 'types' && dispatch(actions.getSensitivityInfo({}));
  }, [selectedTab, dispatch]);

  useEffect(() => {
    selectedTab === 'types' &&
      dispatch(
        sharedStateActions.getLabels({ q: { category: Categories.Data } }),
      );
  }, [dispatch, selectedTab]);

  return (
    <Card
      contentComponent={
        <DataClassifierForm actionType="Add" selectedTab={selectedTab!} />
      }
    />
  );
};
